import {api_v1} from 'utils/api-client';

/**
 * Get all users
 */

export function uploadMetadata(params) {
    return api_v1.post('/assets', params);
}
